/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Attributes_Not_Ready_For_SyncInputs */

const en_error_attributes_not_ready_for_sync = /** @type {(inputs: Error_Attributes_Not_Ready_For_SyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The attributes cannot be sent to Business Central yet.`)
};

/**
* | output |
* | --- |
* | "The attributes cannot be sent to Business Central yet." |
*
* @param {Error_Attributes_Not_Ready_For_SyncInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_attributes_not_ready_for_sync = /** @type {((inputs?: Error_Attributes_Not_Ready_For_SyncInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Attributes_Not_Ready_For_SyncInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_attributes_not_ready_for_sync(inputs)
});